import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { resetPassword } from "../../store/actions/authActions";
import queryString from 'query-string';
import validate from './validateReset';
import { Card, Button, Alert } from 'react-bootstrap';
import { Input, FormFeedback, FormGroup, Label } from 'reactstrap';

class ResetPassword extends Component {
  

  
   
    componentDidMount() {
        const values = queryString.parse(this.props.location.search)
        let email = values.email
        let code = values.code;

        this.setState({
            email : email,
            code : code
        })
       
  }

    handleFormSubmit(data) {
      
      this.props.resetPassword(data, this.onSubmitComplete.bind(this));
  }
 
    onSubmitComplete() {
        window.location.href = "https://play.kinoclub.com/log-in";
   // this.props.history.push("/signin");
  }

  renderHidden = ({input}) => {
    return (
          <input
              type="hidden"
              {...input}       
          />
    );
}

     renderField = (
        { input, label, type, meta: { asyncValidating, touched, error } },
    ) => (
            <div>              
                <div className={asyncValidating ? 'async-validating' : ''}>
                    <input {...input} type={type} placeholder={label} />
                     {touched && error && <span style={{ color: 'red' }}>
                         {error}
                     </span>}
                </div>
            </div>
        );

  render() {
    const { handleSubmit } = this.props;
    //console.log(this.props.auth.isLoading);
    
    return (
        <div className="login-style">

            <Card className="mx-auto">

               
                <Card.Body>
      <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>      
        <div>
          
          <div>
            <Field
                        name="email"
                        component={renderTextField}
              type="email"
                                    placeholder="E-mail"
                        disabled = 'disabled'
              
            />
            <Field
              name="code"
              component="input"
              type="hidden"
              
            />
          </div>
        </div>
        <div>
        
          <div>
            <Field
                        name="password"
                        component={renderTextField}
              type="password"
                                    placeholder="Nyt kodeord"
            />
          </div>
        </div>
        <div> 
         
          <div>
            <Field
                        name="confirmPassword"
                        component={renderTextField}
              type="password"
                                    placeholder="Gentag nyt kodeord"
            />
          </div>
        </div>
        <div>
          <span style={{color: 'red'}}>
                    {this.props.auth.reset_error}
          </span>
        </div>
        <div className="btn-login-container">
                            <Button className="-btnLogin" size="sm" type="submit" disabled={''}>
                                Afslut
          </Button>
        </div>
                    </form>
                </Card.Body>
            </Card></div>                  
    )
  }
}


const renderTextField = ({ placeholder, input,  meta: { asyncValidating, touched, error, warning }, ...custom }) => {
       
    return (
        <Fragment>
            <FormGroup>
              
                <Input placeholder={" "} {...(touched ? { valid: !error } : {})} {...(touched ? { invalid: error } : {})} {...input} {...custom} />
                <Label>{placeholder}</Label>
                {touched && error && <FormFeedback>{error}</FormFeedback>}
            </FormGroup>
        </Fragment>
    )
};


ResetPassword = reduxForm({
  form: 'resetPassword', // a unique identifier for this form,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
})(ResetPassword);

function mapStateToProp(state, ownProps) {
    const values = queryString.parse(ownProps.location.search)
    let email = values.email;
    let code = values.code;
   
    return {
        auth: state.auth,
        initialValues: { email: email, code: code },
        validate
     
  };
}

ResetPassword = connect(mapStateToProp, { resetPassword })(withRouter(ResetPassword));


export default ResetPassword;


// WEBPACK FOOTER //
// ./src/components/auth/ResetPassword.js